module.exports = __webpack_public_path__ + "static/media/Arusher-Script.a68b745e.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Arusher-Script.eot
// module id = 2930
// module chunks = 70